/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Issue_S2Inputs */

const en_mk_tut_issue_s2 = /** @type {(inputs: Mk_Tut_Issue_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write a title that names an outcome, not an activity. “Prepare 3 captions for Monday’s promo” beats “Content”.`)
};

const id_mk_tut_issue_s2 = /** @type {(inputs: Mk_Tut_Issue_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isi judul yang menyebut hasil, bukan aktivitas. "Siapkan 3 caption Promo Senin" lebih berguna daripada "Konten".`)
};

/**
* | output |
* | --- |
* | "Write a title that names an outcome, not an activity. “Prepare 3 captions for Monday’s promo” beats “Content”." |
*
* @param {Mk_Tut_Issue_S2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_issue_s2 = /** @type {((inputs?: Mk_Tut_Issue_S2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Issue_S2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_issue_s2(inputs)
	return en_mk_tut_issue_s2(inputs)
});